
export const errorReducer = (state, action) => {
    if (!action.error) {
        return {
          ...state,
          error: null,
        }
    }
    switch (action.type) {
        case "CREATE_ERROR":
            return {
                ...state,
                error: action.error, // asetetaan virhe
            }
        default:
            return state
    }
}